import { jsx as _jsx } from "react/jsx-runtime";
import { useVehicleThermometerState } from 'console/shared/hooks/device/legacy/thermometers';
import { memo, useMemo } from 'react';
import { ThermometerContent } from './types';
export const VehicleThermometerProvider = memo(function VehicleThermometerProvider(props) {
    const { children, thermometer_config } = props;
    const { id } = thermometer_config;
    const { temperature } = useVehicleThermometerState();
    const thermometer_state = useMemo(() => {
        const thermometer = temperature?.[id];
        if (thermometer) {
            const { state } = thermometer;
            const temperature = 'value' in thermometer ? thermometer.value : undefined;
            return { state, temperature };
        }
        return {};
    }, [temperature, id]);
    const thermometer = useMemo(() => ({
        ...thermometer_config,
        ...thermometer_state,
    }), [thermometer_config, thermometer_state]);
    return (_jsx(ThermometerContent.Provider, { value: thermometer, children: children }));
});
